module.exports = __webpack_public_path__ + "static/media/exclamation.edcb3e2d.svg";